const Xmo = {
  symbol: 'xmo',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm12-16a11.86 11.86 0 0 0-2.381-7.153l-1.96 1.96A9.272 9.272 0 0 1 25.253 16c0 5.11-4.153 9.262-9.262 9.262-5.11 0-9.263-4.153-9.263-9.262a9.22 9.22 0 0 1 1.594-5.194l-1.96-1.96A11.969 11.969 0 0 0 4 16c0 6.628 5.372 12 12 12s12-5.372 12-12zm-5.363 0a6.65 6.65 0 0 0-.871-3.29L16 18.474l-5.766-5.766A6.644 6.644 0 0 0 9.363 16 6.644 6.644 0 0 0 16 22.637 6.644 6.644 0 0 0 22.637 16zm1.21-9.075A11.925 11.925 0 0 0 16 4c-3 0-5.747 1.097-7.847 2.925l1.866 1.866L16 14.762l7.847-7.837z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#F60"/><g fill="#FFF"><path d="M28 16c0 6.628-5.372 12-12 12S4 22.628 4 16c0-2.681.881-5.156 2.362-7.153l1.96 1.96A9.222 9.222 0 0 0 6.728 16c0 5.11 4.153 9.262 9.263 9.262 5.109 0 9.262-4.153 9.262-9.262a9.272 9.272 0 0 0-1.594-5.194l1.96-1.96A11.86 11.86 0 0 1 28 16"/><path d="M22.637 16A6.644 6.644 0 0 1 16 22.637 6.644 6.644 0 0 1 9.362 16c0-1.153.3-2.287.872-3.29L16 18.474l5.766-5.766A6.644 6.644 0 0 1 22.638 16"/><path d="M23.847 6.925L16 14.762l-5.981-5.971-1.866-1.866A11.907 11.907 0 0 1 16 4c3 0 5.738 1.097 7.847 2.925"/></g></g>`;
  }
};
export default Xmo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/xmo.js
// module id = null
// module chunks = 